module.exports = __webpack_public_path__ + "fonts/DINPro-CondLight.91415e80.ttf";